// extracted by mini-css-extract-plugin
export default {"slider-button":"SliderButton_slider-button__qLWmY"};